<template>
  <div class="scroll"><slot></slot></div>
</template>

<script>
export default {
  name: 'scroll-wrapper',
}
</script>

<style scoped>
.scroll {
  height: calc(100vh - 290px);
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
